import { HsaCartEligibilitySummary } from "./hsa-cart-summary";

/**
 * The widget's subtext, sitting under the constant "HSA/FSA Eligible" title.
 * Scopes the claim to qualified customers whenever any eligible line requires
 * a Letter of Medical Necessity, and counts items when only part of the cart
 * is eligible.
 */
export function hsaCartWidgetText(summary: HsaCartEligibilitySummary): string {
  const { eligibleQuantity, fullyEligible, anyRequiresLmn } = summary;
  const subject = fullyEligible
    ? "Items in your cart are"
    : `${eligibleQuantity} ${eligibleQuantity === 1 ? "item" : "items"} in your cart ${
        eligibleQuantity === 1 ? "is" : "are"
      }`;
  return anyRequiresLmn
    ? `${subject} HSA/FSA eligible for qualified customers`
    : `${subject} eligible to be purchased with an HSA/FSA card`;
}
